export const REGISTER_SOCKET = 'REGISTER_SOCKET'

export const registerSocket = socket => {
    return { type: REGISTER_SOCKET, socket }
}


// WEBPACK FOOTER //
// ./src/reducers/socket/actions.js